export default {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, ErrorObject) {
        state.error.message = ErrorObject.message;
    },

    SET_AUTH_ID(state, id) {
        state.authId = id;
    },

    SET_UNSUBSCRIBE_AUTH_OBSERVER(state, unsubscribe) {
        state.unsubscribeAuthObserver = unsubscribe;
    }
};
